import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { PrimaryButton, OutlinedButton } from '../../Reusable/Button';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      // Add padding to the Paper component for overall spacing
      PaperProps={{
        sx: {
          p: 1.5, // This adds padding to the entire dialog box
        },
      }}
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{ fontWeight: 'bold' }} // Make the title text bold
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <OutlinedButton onClick={onClose}>{cancelText}</OutlinedButton>
        <PrimaryButton onClick={onConfirm}>{confirmText}</PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;